// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo__logo___plSjy"};